module.exports = __webpack_public_path__ + "img/product-placeholder.d13bd02b.svg";